import { useState } from 'react';

import { Stack, TooltipProps } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { FacebookShareButton, EmailShareButton, TwitterShareButton } from 'react-share';
import courseAPI from 'src/api/course';
import { SocialShareType } from 'src/helpers/constants';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { IconButtonStyle, LightTooltip, SocialBox } from '@components/share/custom/likeAndShareCourse/style';
import { useProfile } from '@hooks/useProfile';

type ShareCourseIconButtonProps = {
  courseId: number;
  courseUrl: string;
  placement?: TooltipProps['placement'];
  isUseMailTemplate?: boolean;
  courseMailContent: string;
  courseMailSubject: string;
  courseTweeterContent: string;
};

export const ShareCourseIconButton = ({
  courseId,
  placement = 'bottom',
  courseUrl,
  isUseMailTemplate = false,
  courseMailContent,
  courseMailSubject,
  courseTweeterContent,
}: ShareCourseIconButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { profile } = useProfile();

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltip = () => {
    setOpen(!open);
  };

  const getEmailBody = () => {
    if (isUseMailTemplate) {
      return `${courseMailContent}\n\r${t('check_it_out_your_self')} ${courseUrl} ${
        profile ? `\n\rBest,\n\r${profile.firstname}` : ''
      }`;
    }
    return courseMailContent;
  };

  const updateShareCounter = (type: SocialShareType) => {
    courseAPI.updateShareCounter(courseId, type);
  };

  return (
    <LightTooltip
      PopperProps={{
        disablePortal: true,
      }}
      placement={placement}
      className="tooltip"
      onClose={handleTooltipClose}
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={
        <Stack direction="row" sx={{ height: '40px', background: 'white' }}>
          <FacebookShareButton url={courseUrl}>
            <IconButtonStyle onClick={() => updateShareCounter(SocialShareType.Facebook)}>
              <FontAwesomeIcon className="icon social" icon="fa-brands fa-facebook-f" style={{ fontSize: '22px' }} />
            </IconButtonStyle>
          </FacebookShareButton>
          <SocialBox />
          <TwitterShareButton url={courseUrl} title={courseTweeterContent}>
            <IconButtonStyle onClick={() => updateShareCounter(SocialShareType.Twitter)}>
              <FontAwesomeIcon className="icon social" icon="fa-brands fa-x-twitter" style={{ fontSize: '22px' }} />
            </IconButtonStyle>
          </TwitterShareButton>
          <SocialBox />
          <EmailShareButton body={getEmailBody()} url="" subject={courseMailSubject}>
            <IconButtonStyle onClick={() => updateShareCounter(SocialShareType.Email)}>
              <FontAwesomeIcon className="icon social" icon="fa-solid fa-envelope" style={{ fontSize: '22px' }} />
            </IconButtonStyle>
          </EmailShareButton>
        </Stack>
      }
      arrow
    >
      <IconButtonStyle onClick={handleTooltip}>
        <FontAwesomeIcon icon="fa-light fa-share-nodes" style={{ color: '#fff', fontSize: '24px' }} />
      </IconButtonStyle>
    </LightTooltip>
  );
};

export default ShareCourseIconButton;
